(function () {
    'use strict';

    var module = angular.module('uwAgenda.views');
    module.controller('ViewOverviewController', [      
        '$rootScope',
        'ViewsService',  
        'ItemTableService',
        'SharedAgendaService',
        '$uibModal',
        'HelperService',
        '$stateParams',
        '$state',
        ViewOverviewControllerFn]);
    
    function ViewOverviewControllerFn(       
        $rootScope,
        ViewsService, 
        ItemTableService,
        SharedAgendaService,
        $uibModal,
        HelperService,
        $stateParams,
        $state
        ) {

        var vm = this;
        
        vm.views = [];        
        
        activate();
        
        function activate() {              
            loadViews();
            if ($stateParams.id) {                                
                showEditModal({id: parseInt($stateParams.id, 10)});                 
            }
        }

        function loadViews() {
            var viewOwnerId = $rootScope.isRingfoon 
                        ? SharedAgendaService.currentUser().id
                        : SharedAgendaService.getLoggedInUserData().id;

            ViewsService.getViewsForOwner(viewOwnerId)
                       .then(function(views) {
                    vm.views = views;

                    var itemTableService = ItemTableService.Instance();
                    itemTableService.init(vm.views);
                    vm.overview = itemTableService;
                });
        }

        vm.new = function() {

            var isRingphone = $rootScope.isRingfoon;
            var ownerId = isRingphone 
                                ? SharedAgendaService.currentUser().id 
                                : SharedAgendaService.getLoggedInUserData().id;            

            var allSortOrders = vm.views.filter(v => v.forOperators === isRingphone).map(v => v.sortOrder);
            var sortOrder = allSortOrders.length > 0 
                                        ? Math.max(...allSortOrders) + 1
                                        : 1;

            var newView = {
                id: 0,
                name: '',
                ownerId: ownerId, 
                forOperators: isRingphone,
                viewUsers: [],
                sortOrder: sortOrder
            };
            showEditModal(newView);
        }

        vm.edit = function(view) {
            showEditModal(view);
        }

        vm.delete = function(view) {
            var confirmationModal = HelperService.deactivatingConfirmationModal();
            confirmationModal.result.then(function() {
                return ViewsService.deleteView(view.id)
                                    .then(function() {
                                       loadViews();
                                    });
            });
        }

        function showEditModal(view) {           
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/views/view-detail.html',
                controller: 'ViewDetailController',
                controllerAs: 'vm',
                size: 'xl',
                resolve: {
                    view: ['ViewsService', function (ViewsService) {
                        if (view.id <= 0) {
                            return view;
                        }
                        
                        return ViewsService
                                    .getView(view.id)
                                    .then(function (loadedView) {
                            return loadedView;
                        });
                    }]
                }
            });

            // modal is closed
            modalInstance.result.then(function (item) {
                if ($stateParams.id) {
                    $state.go('Home.Views', { id: null }, { inherit: false });  
                } else {
                    return loadViews();

                }
            }, function() {
                if ($stateParams.id) {
                    $state.go('Home.Views', { id: null }, { inherit: false });  
                } 
            });
        }        
    }
})();
